import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import { CnActionSheet, } from './action-sheet';
class ActionSheetWrapper extends Component {
    static defaultProps = {
        message: '',
        options: [],
        onClick: () => { },
        onClose: () => { },
    };
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
        };
    }
    handleClick = (option, index, e) => {
        if (this.props.onClick) {
            this.props.onClick(option, index, e);
        }
    };
    handleClose = (reason) => {
        this.setState({
            visible: false,
        });
        if (this.props.onClose) {
            this.props.onClose(reason);
        }
    };
    render() {
        const { message, options, ...others } = this.props;
        const { visible } = this.state;
        return (React.createElement(CnActionSheet, { visible: visible, ...others, message: message, options: options, onClose: this.handleClose, onClick: this.handleClick }));
    }
}
function renderElement(element, onHide) {
    const root = document.createElement('div');
    let hid = false;
    const hide = () => {
        if (hid) {
            return;
        }
        try {
            hid = true;
            ReactDOM.unmountComponentAtNode(root);
            document.body.removeChild(root);
            if (onHide) {
                onHide();
            }
        }
        catch (e) {
            throw new Error('remove element error');
        }
    };
    document.body.appendChild(root);
    ReactDOM.render(element, root);
    return hide;
}
/**
 * 显示 ActionSheet
 * @param {Object} options
 */
export default function (options) {
    const { onClose, ...others } = options;
    let hide = () => { };
    const handleClose = (v) => {
        if (typeof onClose === 'function') {
            onClose(v);
        }
        setTimeout(() => {
            hide();
        }, 300);
    };
    hide = renderElement(React.createElement(ActionSheetWrapper, { ...others, onClose: handleClose }));
    return {
        close: () => hide(),
    };
}
